import React from "react";
import { TextField as MUITextField, TextFieldProps } from "@material-ui/core";

type Props = TextFieldProps;

export const TextField = (props: Props) => {
  const { ...rest } = props;
  return <MUITextField {...rest} />;
};
